import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
    whatsapp_number: "918058876405",
    phone_display: "+91 80588 76405",
    email: "contact@goldbysrn.com",
    address: "Jaipur, Rajasthan, India",
    business_hours: "Mon - Sat, 10:00 AM - 7:00 PM",
    instagram: "https://instagram.com/goldbysrn",
    tagline: "Crafted in Jaipur. Trusted by Jewellers across India.",
    shopify_domain: "",
    shopify_storefront_token: "",
};

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(FALLBACK);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings({ ...FALLBACK, ...data });
        } catch (err) {
            console.warn("[Settings] failed to load — using fallback:", err);
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const value = useMemo(
        () => ({ settings, loaded, refresh, setSettings }),
        [settings, loaded, refresh]
    );

    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => {
    const ctx = useContext(SettingsContext);
    if (!ctx) throw new Error("useSettings must be used inside SettingsProvider");
    return ctx;
};
